import React from "react"

type RenderProps = {
  label: string
}

const MandatoryIndicator: React.FC<RenderProps> = ({ label }) => (
  <>
    <span aria-hidden="true">&nbsp;*</span>
    <span className="sr-only"> ({label})</span>
  </>
)

export default MandatoryIndicator
